/* eslint-disable react/display-name */
import {
  childrenSelector,
  labelSelector,
  valueSelector,
} from '@smartsheet-dataflow/formjs';
import { EntityId } from '@smartsheet-dataflow/formjs-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { PartialBy } from '../../../utils/types';

interface WithFormJSEnumsFromChildrenProps {
  options: string[];
}

export const withFormJSEnumsFromChildren =
  <P extends EntityId & WithFormJSEnumsFromChildrenProps>(
    Component: React.ComponentType<P>
  ) =>
  (props: PartialBy<P, 'options'>) => {
    const children = useSelector(childrenSelector(props.id));

    const options = children.map((optionId: string) => ({
      label: useSelector(labelSelector(optionId)),
      value: useSelector(valueSelector(optionId)) as string | number,
    }));

    return <Component {...(props as P)} options={options} />;
  };
